import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useEffect } from 'react';
// import { formatCardNumber2 } from 'utils/formate';
// import Visibility from 'assets/images/eye-open.svg';
// import VisibilityOff from 'assets/images/eye-off.svg';
// import styled from 'styled-components';
interface FieldChange {
  key: string;
  changedValue: string[]; // 根据key，可能是字符串数组或地址数组
  originalValue: string[];
}
interface listCode {
  label: string;
  value: string;
  chineseDescription: string;
  description: string;
}
interface commonListProps {
  label: string;
  labelTc: string;
  value: string;
  code: string;
}

export const PaymentConfrimCard = (props: {
  fieldChanges: FieldChange[];
  myBankList: listCode[];
  dividendOptionsList: commonListProps[];
  paymentOptionsList: commonListProps[];
  paymentMethodList: commonListProps[];
  chequeList: commonListProps[];
  annPaymentMethodList: commonListProps[];
  // paymentAccountNo: string;
  // diviAccountNo: string;
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  // const [showCardMask, setShowCardMask] = useState<boolean>(true);
  // const [showCardMask2, setShowCardMask2] = useState<boolean>(true);
  // const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');

  useEffect(() => {
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%', props.fieldChanges);
  }, [props.fieldChanges]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const myBankList: { label: string; value: string }[] = [];
  // bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
  //   myBankList.push({
  //     label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
  //     value: item.bankCode,
  //   });
  // });

  // useEffect(() => {
  //   const a = myBankList?.find((item) => item.value === form.getFieldValue('bankCode'))?.label;
  //   if (a) {
  //     setbankdefult(a);
  //   }
  //   // eslint-disable-line react-hooks/exhaustive-deps
  // }, [myBankList, form]);
  // const changeToTc = (value: string) => {
  //   switch (value) {
  //     case 'Cash Payment':
  //       return i18n.language == 'en' ? value : '支取現金';
  //     case 'Accumulate with interest':
  //       return i18n.language == 'en' ? value : '積存生息';
  //     case 'Paid Up Additions':
  //       return i18n.language == 'en' ? value : '購買繳費保險';
  //     case 'Credit to Policyholder’s local bank account in Hong Kong currency':
  //       return i18n.language == 'en' ? value : '轉帳至保單持有人本地銀行之港幣戶囗';
  //     case 'Cheque':
  //       return i18n.language == 'en' ? value : '現金';
  //     case 'USD':
  //       return i18n.language == 'en' ? value : '美金';
  //     case 'HKD':
  //       return i18n.language == 'en' ? value : '港幣';
  //     default:
  //       return value;
  //   }
  // };
  // const changeCardMask = () => {
  //   setShowCardMask(!showCardMask);
  // };
  // const changeCardMask2 = () => {
  //   setShowCardMask2(!showCardMask2);
  // };
  const changeToTc = (key: string, value: string) => {
    switch (key) {
      // case 'Cash Payment':
      //   return i18n.language == 'en' ? value : '支取現金';
      // case 'Accumulate with interest':
      //   return i18n.language == 'en' ? value : '積存生息';
      // case 'Paid Up Additions':
      //   return i18n.language == 'en' ? value : '購買繳費保險';
      case 'paymentOptionsCashPaymentMethod': {
        const labelObj = props.annPaymentMethodList.find((i) => i.value == value);
        return i18n.language == 'en' ? labelObj?.label : labelObj?.labelTc;
      }
      case 'dividendOptionsCashPaymentMethod': {
        const labelObj1 = props.paymentMethodList.find((i) => i.value == value);
        return i18n.language == 'en' ? labelObj1?.label : labelObj1?.labelTc;
      }
      case 'dividendOptionsCashPaymentMethodCheque': {
        const labelObj2 = props.chequeList.find((i) => i.value == value);
        return i18n.language == 'en' ? labelObj2?.label : labelObj2?.labelTc;
      }
      case 'paymentOptionsCashPaymentMethodCheque': {
        const labelObj3 = props.chequeList.find((i) => i.value == value);
        return i18n.language == 'en' ? labelObj3?.label : labelObj3?.labelTc;
      }
      default:
        return value;
    }
  };
  const finddropLabel = (value: string, key: string) => {
    if (!value) return '';
    let obj = {} as commonListProps | undefined;
    if (key == 'dividendOptions') {
      if (props.dividendOptionsList.length > 0) {
        obj = props.dividendOptionsList.find((i) => i.value == value);
      }
    } else {
      if (props.paymentOptionsList.length > 0) {
        obj = props.paymentOptionsList.find((i) => i.value == value);
      }
    }
    return i18n.language == 'en' ? obj?.label : obj?.labelTc;
  };
  return (
    <div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {props.fieldChanges.map((item) => {
          if (
            item.key == 'dividendOptionsCashPaymentMethodBankCode' ||
            item.key == 'paymentOptionsCashPaymentMethodBankCode'
          ) {
            return (
              <Col xs={24} md={24} key={item.key}>
                <BoldLabelFormItem
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t(`life.policyOptions.${item.key}`)}
                    </span>
                  }
                  name={item.key}
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div> {props.myBankList.find((i) => i.value == form.getFieldValue(item.key))?.label}</div>
                  </div>
                </BoldLabelFormItem>
              </Col>
            );
          }
          if (item.key == 'dividendOptions' || item.key == 'paymentOptions') {
            return (
              <Col xs={24} md={24} key={item.key}>
                <BoldLabelFormItem
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t(`life.policyOptions.${item.key}`)}
                    </span>
                  }
                  name={item.key}
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>{finddropLabel(form.getFieldValue(item.key), item.key)}</div>
                  </div>
                </BoldLabelFormItem>
              </Col>
            );
          }
          // if (
          //   item.key == 'dividendOptionsCashPaymentMethodAccountNo' ||
          //   item.key == 'paymentOptionsCashPaymentMethodAccountNo'
          // ) {
          //   return (
          //     <Col xs={24} md={24}>
          //       <BoldLabelFormItem
          //         label={
          //           <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
          //             {t(`life.policyOptions.${item.key}`)}
          //           </span>
          //         }
          //         name="bankAccountNumber"
          //       >
          //         <div
          //           style={{
          //             border: 'none',
          //             borderBottom: '1px solid #CCCCCC',
          //             // color: "white",
          //             backgroundColor: 'transparent',
          //             fontSize: '20px',
          //             fontFamily: 'Roboto400',
          //             marginBottom: '10px',
          //             padding: '4px 0',
          //             display: 'flex',
          //             justifyContent: 'space-between',
          //           }}
          //         >
          //           {(item.key == 'dividendOptionsCashPaymentMethodAccountNo' ? !showCardMask : !showCardMask2)
          //             ? item.key == 'dividendOptionsCashPaymentMethodAccountNo'
          //               ? props.diviAccountNo
          //               : props.paymentAccountNo
          //             : formatCardNumber2(
          //                 item.key == 'dividendOptionsCashPaymentMethodAccountNo'
          //                   ? props.diviAccountNo
          //                   : props.paymentAccountNo,
          //               )}
          //           {(item.key == 'dividendOptionsCashPaymentMethodAccountNo' ? showCardMask : showCardMask2) ? (
          //             <img
          //               src={Visibility}
          //               onClick={
          //                 item.key == 'dividendOptionsCashPaymentMethodAccountNo' ? changeCardMask : changeCardMask2
          //               }
          //             />
          //           ) : (
          //             <img
          //               src={VisibilityOff}
          //               onClick={
          //                 item.key == 'dividendOptionsCashPaymentMethodAccountNo' ? changeCardMask : changeCardMask2
          //               }
          //             />
          //           )}
          //         </div>
          //       </BoldLabelFormItem>
          //     </Col>
          //   );
          // }
          return (
            <Col xs={24} md={24} key={item.key}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                    {t(`life.policyOptions.${item.key}`)}
                  </span>
                }
                name={item.key}
              >
                <div
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #CCCCCC',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div> {changeToTc(item.key, form.getFieldValue(item.key))}</div>
                </div>
              </BoldLabelFormItem>
            </Col>
          );
        })}
        {/* {form.getFieldValue('IncomePaymentOptions') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.IncomePaymentOptions')}
                </span>
              }
              name="IncomePaymentOptions"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('IncomePaymentOptions')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('CashPaymentMethod') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.dividendOptionsCashPaymentMethod')}
                </span>
              }
              name="CashPaymentMethod"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('CashPaymentMethod')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )} */}
      </Row>

      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {/* {form.getFieldValue('chequeCurrency') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.chequeCurrency')}
                </span>
              }
              name="chequeCurrency"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('chequeCurrency')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('bankCode') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.BankCode')}
                </span>
              }
              name="bankCode"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {bankdefult}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('branchNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.BranchNumber')}
                </span>
              }
              name="branchNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('branchNumber')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('bankAccountNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.BankAccountNumber')}
                </span>
              }
              name="bankAccountNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('bankAccountNumber')}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('accountHolder') && form.getFieldValue('branchNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.policyOptions.AccountHolderName')}
                </span>
              }
              name="accountHolder"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('accountHolder')}
              </div>
            </BoldLabelFormItem>
          </Col>
        )} */}
      </Row>
    </div>
  );
};
